import styled from 'styled-components';
import Icons from '../../../../Elements/Icons';
export const Number = styled.div `
  ${({ theme }) => theme.typography.textSmall}
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme, active }) => (active ? theme.colors.main : theme.colors.grey70_1)};
  color: ${({ theme }) => theme.colors.grey00_1};
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;
export const Wrapper = styled.div `
  ${({ theme }) => theme.typography.textMedium}
  ${({ theme }) => theme.typography.weightMedium}
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 12px;
  cursor: pointer;
  color: ${({ theme, active }) => (active ? theme.colors.black_1 : theme.colors.grey100_1)};
  background-color: ${({ theme }) => theme.colors.grey00_6};

  &:hover {
    color: ${({ theme, active }) => (active ? theme.colors.blackDark_1 : theme.colors.black_1)};
    background-color: ${({ theme }) => theme.colors.grey05_1};

    & > ${Number} {
      background-color: ${({ theme, active }) => (active ? theme.colors.mainDark : theme.colors.grey70_1)};
    }
  }
`;
export const IconWrapper = styled.div `
  margin-left: auto;
  display: flex;
  align-items: center;
`;
export const OutlineWarningIcon = styled(Icons.Warning) `
  display: block;

  ${Wrapper}:hover & {
    display: none;
  }
`;
export const FilledWarningIcon = styled(Icons.Warning) `
  display: none;

  ${Wrapper}:hover & {
    display: block;
  }
`;
